import React from "react"

export const themes = {
    light: {
      foreground: '#DDDDDD',
      background: '#242424',
      primaryColor: '#006F3D',
      secondaryColor: '#9D0A0E',
      secondaryText: '#979797'
    },
    dark: {
      foreground: '#FFFFFF',
      background: '#242424',
      primaryColor: '#FF3C3C',
      secondaryColor: '#FEA259',
      foregroundSecondary: '#DDDDDD',
      borderColor: '#686767',
      primaryGradient: `linear-gradient(to top, #FF3C3C, #FEA259)`
    },
  };
  
  export const ThemeContext = React.createContext();
